import { EntityModel } from 'src/core/services/data/models';
import { DataService, property } from 'src/core/services/data.service';
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';

export class SellMarginPolicyListDataService extends DataService<typeof Model.Bookings.Logic.ViewModels.SellMarginPolicySummary, Model.Bookings.Logic.ViewModels.SellMarginPolicySummary, SellMarginPolicySummary> {
	protected map(entity: Model.Bookings.Logic.ViewModels.SellMarginPolicySummary): SellMarginPolicySummary {
		return new SellMarginPolicySummaryModel(entity);
	}

	static make(ctx?: any): SellMarginPolicyListDataService {
		return new SellMarginPolicyListDataService(ctx, ctx => ctx.SellMarginPolicySummaries);
	}
}

export class SellMarginPolicySummaryModel extends EntityModel<Model.Bookings.Logic.ViewModels.SellMarginPolicySummary, SellMarginPolicySummary> implements SellMarginPolicySummary {
	@property<SellMarginPolicySummaryModel>(o => o.entity.id, (o, value) => o.entity.id = value)
	public id: number;

	@property<SellMarginPolicySummaryModel>(o => o.entity.displayName, (o, value) => o.entity.displayName = value)
	public displayName: string;

	@property<SellMarginPolicySummaryModel>(o => o.entity.isActive, (o, value) => o.entity.isActive = value)
	public isActive: boolean;

	@property<SellMarginPolicySummaryModel>(o => parseFloat(o.entity.margin.toString()), (o, value) => o.entity.margin = value)
	public margin: number;

	@property<SellMarginPolicySummaryModel>(o => o.entity.priceRoundingType, (o, value) => o.entity.priceRoundingType = value)
	public priceRoundingType: number;

	@property<SellMarginPolicySummaryModel>(o => o.entity.priority, (o, value) => o.entity.priority = value)
	public priority: number;

	@property<SellMarginPolicySummaryModel>(o => o.entity.hasRules, (o, value) => o.entity.hasRules = value)
	public hasRules: boolean;
}



// WEBPACK FOOTER //
// ./src/app/bookings/sell-margin-policies/list/sell-margin-policy-list.data.ts